export default __webpack_public_path__ + "static/media/char2.621df59f.svg";